module.exports = __webpack_public_path__ + "./docs/img/icon-changelog.afab5dc52fd3a227ad5373030dc85c16.svg";